import React from 'react';
import Link from 'shared/Link.jsx';

const NotFoundPage = () => (
  <div>
    <Link
      className="btn btn-primary btn-lg"
      to=""
    >{`Go Back Home`}</Link>
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/features/shared/NotFoundPage.jsx